import { http as e } from "@frontends/data-access-spg-api";
import { useQuery as t } from "@tanstack/react-query";
//#region src/lib/session.ts
var n = ["session"];
function r(e) {
	return e.httpStatus === 401;
}
function i() {
	return t({
		queryKey: n,
		queryFn: async ({ signal: t }) => {
			let { data: n } = await e.get("/users/me", { signal: t });
			return {
				email: n.email,
				displayName: n.display_name || n.email
			};
		},
		staleTime: Infinity
	});
}
async function a() {
	let { data: t } = await e.get("/users/sign-in");
	window.location.assign(t.url);
}
async function o() {
	await e.post("/users/logout");
}
//#endregion
export { n as SESSION_QUERY_KEY, r as isUnauthorized, o as signOut, a as startSignIn, i as useSessionQuery };
